'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
require('../style-222d2b0f.js');
var span = require('../typography/span.js');
var buttonsColor = require('../buttons-color-d198c1b7.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  height: 55px;\n  font-size: 20px;\n  font-weight: bold;\n  font-family: Merriweather, sans-serif;\n  padding: 0px ", ";\n  border-radius: ", ";\n  @media (max-width: 767px) {\n    padding: 0px 40px;\n  }\n"], ["\n  height: 55px;\n  font-size: 20px;\n  font-weight: bold;\n  font-family: Merriweather, sans-serif;\n  padding: 0px ", ";\n  border-radius: ", ";\n  @media (max-width: 767px) {\n    padding: 0px 40px;\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: ", ";\n"], ["\n  width: 100%;\n  border-radius: ", ";\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  padding: 0px ", ";\n  border-radius: ", ";\n"], ["\n  padding: 0px ", ";\n  border-radius: ", ";\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: 0 0 0 0;\n  cursor: not-allowed;\n"], ["\n  background: ", ";\n  box-shadow: 0 0 0 0;\n  cursor: not-allowed;\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  position: relative;\n  overflow: hidden;\n  z-index: 0;\n  height: ", ";\n  cursor: pointer;\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", " ", ";\n  ", ";\n  ", "\n  ", "\n  ", "\n\n  ", "\n  \n  &:hover > .background {\n    transition: all, 0.5s;\n    transform: translateX(50%);\n  }\n  ", ";\n"], ["\n  ", ";\n  position: relative;\n  overflow: hidden;\n  z-index: 0;\n  height: ", ";\n  cursor: pointer;\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", " ", ";\n  ", ";\n  ", "\n  ", "\n  ", "\n\n  ", "\n  \n  &:hover > .background {\n    transition: all, 0.5s;\n    transform: translateX(50%);\n  }\n  ", ";\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 200%;\n  height: 100%;\n  z-index: -1;\n  ", ";\n  transition: all, 0.5s;\n  &:hover {\n    transition: all, 0.5s;\n    transform: translateX(50%);\n  }\n  pointer-events: none;\n  ", ";\n"], ["\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 200%;\n  height: 100%;\n  z-index: -1;\n  ", ";\n  transition: all, 0.5s;\n  &:hover {\n    transition: all, 0.5s;\n    transform: translateX(50%);\n  }\n  pointer-events: none;\n  ", ";\n"]),
    _templateObject7 = _babelHelpers.taggedTemplateLiteral(["\n  pointer-events: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  pointer-events: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]),
    _templateObject8 = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  border-radius: 12px;\n  ", ";\n  font-family: Source Sans Pro, sans-serif;\n  color: white;\n  ", ";\n  position: absolute;\n  font-weight: 600;\n  ", ";\n  right: -12px;\n"], ["\n  ", ";\n  ", ";\n  border-radius: 12px;\n  ", ";\n  font-family: Source Sans Pro, sans-serif;\n  color: white;\n  ", ";\n  position: absolute;\n  font-weight: 600;\n  ", ";\n  right: -12px;\n"]),
    _templateObject9 = _babelHelpers.taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  ", ";\n  ", ";\n"], ["\n  position: relative;\n  display: inline-block;\n  ", ";\n  ", ";\n"]);

var extraLargeBtn = styled.css(_templateObject, settings.XL_BUTTON_PADDING, settings.XL_BUTTON_BORDER_RADIUS);
var largeBtn = styled.css(_templateObject2, settings.LARGE_BUTTON_BORDER_RADIUS);

var smallBtn = styled.css(_templateObject3, settings.SMALL_BUTTON_PADDING, settings.SMALL_BUTTON_BORDER_RADIUS);

var grayDisabled = styled.css(_templateObject4, settings.COLOR.veryLightGray);

var gradientHoveredColors = {
  blue: buttonsColor.blueGradientHovered,
  yellow: buttonsColor.yellowGradientHovered,
  red: buttonsColor.redGradientHovered,
  secondary: buttonsColor.secondaryGradientHovered
};

var StyledButton = styled__default(span)(_templateObject5, settings.FLEX_CENTER, settings.BUTTON_HEIGHT, function (props) {
  return props.google && buttonsColor.googleBtn;
}, function (props) {
  return props.facebook && buttonsColor.facebookBtn;
}, function (props) {
  return props.blueBtn && buttonsColor.blueBtn;
}, function (props) {
  return props.transparent && buttonsColor.transparentBtn;
}, function (props) {
  return props.fontSize && "font-size: " + props.fontSize + ";";
}, function (props) {
  return props.gradientHovered && gradientHoveredColors[props.gradientHovered];
}, function (props) {
  return props.greenGradient && buttonsColor.greenGradientBtn;
}, function (props) {
  return props.blackText && buttonsColor.blackTextBtn;
}, function (props) {
  return props.large && largeBtn;
}, function (props) {
  return props.small && smallBtn;
}, function (props) {
  return props.extraLarge && extraLargeBtn;
}, function (props) {
  return props.blueText && buttonsColor.blueText;
}, function (props) {
  return props.shadow && "box-shadow: " + settings.BUTTON_SHADOW;
}, function (props) {
  return props.shadowLevel2 && "box-shadow: " + settings.CHECKBOX_HOVER_SHADOW;
}, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.minWidth && "min-width: " + props.minWidth + "px";
}, function (props) {
  return props.padding && "padding: " + props.padding;
}, function (props) {
  return props.justifyContent && "justify-content: " + props.justifyContent;
}, function (props) {
  return props.sourceSansPro && "font-family: Source Sans Pro, sans-serif;";
}, function (props) {
  return props.height && "height: " + props.height;
}, function (props) {
  return props.fontWeight && "font-weight: " + props.fontWeight;
}, function (props) {
  return props.tWidth && "\n  @media (max-width: 991px) {\n    width: " + props.tWidth + ";\n  }";
}, function (props) {
  return props.tHeight && "\n  @media (max-width: 991px) {\n    height: " + props.tHeight + ";\n  }";
}, function (props) {
  return props.mWidth && "\n  @media (max-width: 767px) {\n    width: " + props.mWidth + ";\n  }";
}, function (props) {
  return props.mHeight && "\n  @media (max-width: 767px) {\n    height: " + props.mHeight + ";\n  }";
}, function (props) {
  return props.disabled && "\n    cursor: not-allowed;\n    box-shadow: 0 0 0 0;\n  ";
});

StyledButton.propTypes = {
  id: PropTypes$1.string.isRequired
};

var gradientColors = {
  blue: buttonsColor.blueGradient,
  yellow: buttonsColor.yellowGradient,
  red: buttonsColor.redGradient,
  secondary: buttonsColor.secondaryGradient
};

var GradientBg = styled__default.div(_templateObject6, function (props) {
  return props.gradient ? gradientColors[props.gradient] : gradientColors.blue;
}, function (props) {
  return props.grayDisabled && grayDisabled;
});
var ButtonIcon = styled__default.i(_templateObject7, function (props) {
  return "font-size: " + (props.size ? props.size : "18px");
}, function (props) {
  return "line-height: " + (props.lineHeight ? props.lineHeight : "40px");
}, function (props) {
  return props.ml && "margin-left: 5px";
}, function (props) {
  return props.mr && "margin-right: 5px";
}, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.width && "width: " + props.width + "px";
}, function (props) {
  return props.color && "color: " + props.color;
});

var ButtonBadge = styled__default.div(_templateObject8, function (props) {
  return "padding: " + (props.padding ? "" + props.padding : "2px 11px");
}, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return "font-size: " + (props.size ? props.size : "14px");
}, function (props) {
  return props.bgColor && "background-color: " + props.bgColor;
}, function (props) {
  return "top: " + (props.top ? "" + props.top : "-13px");
});
var ButtonBadgeContainer = styled__default.div(_templateObject9, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.padding && "padding: " + props.padding;
});

exports.ButtonBadge = ButtonBadge;
exports.ButtonBadgeContainer = ButtonBadgeContainer;
exports.ButtonIcon = ButtonIcon;
exports.GradientBg = GradientBg;
exports.StyledButton = StyledButton;
exports.default = ButtonIcon;
exports.extraLargeBtn = extraLargeBtn;
exports.largeBtn = largeBtn;
exports.smallBtn = smallBtn;
//# sourceMappingURL=button-icon.js.map
